import { render, staticRenderFns } from "./AuthInit.vue?vue&type=template&id=553f52c0&"
import script from "./AuthInit.vue?vue&type=script&lang=js&"
export * from "./AuthInit.vue?vue&type=script&lang=js&"
import style0 from "./AuthInit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports